import vdiImg from "public/iaas/virtual_device_infrastructure.png";
import { SimpleList } from "@/components/list";

const GLOBAL_POINTS = [
  "Multiple locations providing worldwide access to strategic data centers.",
  "Planned expansions in major global cities for future scalability.",
];

const HAR_POINTS = [
  "99.99% SLA ensuring minimal downtime and consistent performance.",
  "Redundant infrastructure with backup power and failover systems.",
];

const SECURITY_POINTS = [
  "Advanced security measures including 24/7 surveillance and biometric access.",
  "Compliance certifications adhering to industry standards and regulations.",
];

const SCALABILITY_POINTS = [
  "Customizable colocation plans tailored to business needs.",
  "Flexible contracts allowing businesses to scale as needed.",
  "Economy of scale & special partner pricing for cost-effective solutions.",
];

export const SOLUTIONS_CONSTANTS = {
  title: "Features of Colocation",
  list: [
    {
      content: <SimpleList points={GLOBAL_POINTS} />,
      image: vdiImg,
      title: "Global Data Center Presence",
    },
    {
      content: <SimpleList points={HAR_POINTS} />,
      image: vdiImg,
      title: "High Availability & Reliability",
    },
    {
      content: <SimpleList points={SECURITY_POINTS} />,
      image: vdiImg,
      title: "Security & Compliance",
    },
    {
      content: <SimpleList points={SCALABILITY_POINTS} />,
      image: vdiImg,
      title: "Scalability, Flexibility & Cost Efficiency",
    },
  ],
};
